import React from 'react'
import PropTypes from 'prop-types'
import {
  ScrollView, Text, View,
} from 'react-native'
import { Dialog, Portal } from 'react-native-paper'
import LinearGradient from 'react-native-web-linear-gradient'
import styles from '../../styles'
import dialogStyles from '../../styles/dialog'
import DialogButton from './DialogButton'

const renderSupportNumber = () => (
  <View style={{ paddingBottom: 40 }}>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_AU">
        Australia:
        {' '}
      </Text>
      1800 528 488
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_BE">
        Belgique / België:
        {' '}
      </Text>
      0800 80697
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_BR">
        Brasil:
        {' '}
      </Text>
      0800-047-4959
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_CA">
        Canada:
        {' '}
      </Text>
      1 800 227 3422
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_CN">
        China / 中国:
        {' '}
      </Text>
      4008801427
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_CO">
        Colombia:
        {' '}
      </Text>
      18000110181
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_CZ">
        Czech Republic:
        {' '}
      </Text>
      239 016 657
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_DK">
        Denmark:
        {' '}
      </Text>
      70 10 01 82
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_DE">
        Deutschland:
        {' '}
      </Text>
      069 51709 481
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_ES">
        España:
        {' '}
      </Text>
      900 806 108
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_FI">
        Finland:
        {' '}
      </Text>
      010 80 48 19
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_FR">
        France:
        {' '}
      </Text>
      0805 5404 22
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_GR">
        Greece:
        {' '}
      </Text>
      442 035 647 788
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_HK">
        Hong Kong:
        {' '}
      </Text>
      852 8105 5433
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_HU">
        Hungary:
        {' '}
      </Text>
      06 80 981 579
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_IS">
        Iceland:
        {' '}
      </Text>
      8004174
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_IE">
        Ireland (Republic):
        {' '}
      </Text>
      1800 851 861
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_IL">
        Israel:
        {' '}
      </Text>
      1 809 303 136
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_IT">
        Italia:
        {' '}
      </Text>
      800 959 182
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_JP">
        Japan / 日本:
        {' '}
      </Text>
      0120 033 686
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_KW">
        Kuwait:
        {' '}
      </Text>
      22089688
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_LB">
        Lebanon:
        {' '}
      </Text>
      +961 1 956 777
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_MY">
        Malaysia:
        {' '}
      </Text>
      (603) 7808 8000
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_MX">
        México:
        {' '}
      </Text>
      +52 1 55 59924179
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_NL">
        Nederland:
        {' '}
      </Text>
      0800 0292077
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_NZ">
        New Zealand:
        {' '}
      </Text>
      0508 200 886
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_NO">
        Norway:
        {' '}
      </Text>
      81 00 00 47
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_PL">
        Poland:
        {' '}
      </Text>
      22 306 07 33
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_PT">
        Portugal:
        {' '}
      </Text>
      800844729
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_QA">
        Qatar:
        {' '}
      </Text>
      800 6520
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_SA">
        Saudi Arabia:
        {' '}
      </Text>
      800 844 8246
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_CH">
        Schweiz / Suisse / Svizzera:
        {' '}
      </Text>
      0844 000110
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_SG">
        Singapore:
        {' '}
      </Text>
      18006224909
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_SK">
        Slovak Republic:
        {' '}
      </Text>
      42/12 686 223 89
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_ZA">
        South Africa:
        {' '}
      </Text>
      800228000
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_KR">
        South Korea:
        {' '}
      </Text>
      +82–2–3483–1782
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_SE">
        Sweden:
        {' '}
      </Text>
      020 160 57 07
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_TH">
        Thailand:
        {' '}
      </Text>
      1800012420
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_AE">
        United Arab Emirates:
        {' '}
      </Text>
      800035770015
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_GB">
        United Kingdom:
        {' '}
      </Text>
      0800 678 16 44
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_US">
        United States:
        {' '}
      </Text>
      1 800 227 3422
    </Text>
    <Text style={styles.globalNumbersDialogText}>
      <Text style={[styles.globalNumbersDialogText, { fontWeight: 'bold' }]} testID="contact_number_AT">
        Österreich:
        {' '}
      </Text>
      0800 202289
    </Text>
  </View>

)

function GlobalCustomerSupportNumbersPopup(props) {
  const { t, visible, onHide } = props
  return (
    <Portal>
      <Dialog
        testID="underage-dialog"
        visible={visible}
        onDismiss={onHide}
      >
        <Dialog.Title testID="global-support-numbers-dialog-title" style={dialogStyles.dialogTitle}>
          {t('common:callLatitudeCustomerSupport')}
        </Dialog.Title>
        <Dialog.Content style={styles.globalNumbersDialogContent}>
          <ScrollView
            testID="scrollview-global-support-numbers"
          >
            {renderSupportNumber()}
          </ScrollView>
        </Dialog.Content>
        <LinearGradient
          style={[styles.globalNumbersScrollGradient]}
          colors={['rgba(255, 255, 255, 0)', 'rgba(255, 255, 255, 1.0)']}
          pointerEvents="none"
        />
        <Dialog.Actions>
          <View style={dialogStyles.dialogSingleAction}>
            <DialogButton accessibilityLabel={t('access:closeButton')} buttonText={t('common:closeButton')} testID="global-support-numbers-ok-btn" onPress={onHide} />
          </View>
        </Dialog.Actions>
      </Dialog>
    </Portal>
  )
}

GlobalCustomerSupportNumbersPopup.propTypes = {
  t: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
}

export default GlobalCustomerSupportNumbersPopup
